import React from "react";

const VARIANTS = {
  primary: "bg-primary text-white shadow-sm hover:bg-primary-dark",
  secondary:
    "border border-slate-300 bg-surface text-slate-700 hover:border-slate-400 hover:bg-slate-50 " +
    "dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:border-slate-600 dark:hover:bg-slate-800",
  ghost:
    "text-slate-600 hover:bg-slate-100 hover:text-slate-900 " +
    "dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-50",
  danger:
    "border border-danger/40 text-danger-dark hover:bg-danger/10 dark:text-danger-light dark:hover:bg-danger/15",
};
// Old variant names are kept so other screens do not break: they look like "secondary".
VARIANTS.success = VARIANTS.secondary;

const SIZES = {
  sm: "h-8 gap-1.5 px-3 text-xs",
  md: "h-9 gap-2 px-3.5 text-sm",
};

/**
 * The single button for the whole project.
 * variant: primary | secondary | ghost | danger
 * icon: component from ui/icons; iconClassName colors only the icon (e.g. Excel green).
 */
export default function Button({
  variant = "primary",
  size = "md",
  icon: Icon,
  iconClassName = "",
  children,
  className = "",
  disabled,
  type = "button",
  ...rest
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`inline-flex select-none items-center justify-center whitespace-nowrap rounded-md font-medium
        transition duration-150 active:translate-y-px
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-1
        ring-offset-white dark:ring-offset-slate-900
        disabled:pointer-events-none disabled:opacity-40
        ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size]} ${className}`}
      {...rest}
    >
      {Icon && <Icon aria-hidden="true" className={`${size === "sm" ? "text-sm" : "text-base"} shrink-0 ${iconClassName}`} />}
      {children}
    </button>
  );
}
